import { useQuery } from "@tanstack/react-query";
import { getAddressByCep } from "../services/api/via-cep";
export var useGetAddressByCep = function (cep) {
    return useQuery({
        queryKey: ["get-address-by-cep", cep],
        queryFn: function () { return getAddressByCep(cep); },
        enabled: Boolean(cep && cep.length >= 9),
    });
};
